<template>
  <div id="func-14">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
      :voltar="voltarNavegacao"
    />
    <div class="func-options">
      <div>
        <dashItem
          :icon="'el-icon-add-location'"
          :link="{ path: '/14/historico' }"
          :title="'Histórico de débitos'"
        />
      </div>
      <div class="clearfix"></div>
    </div>
    <el-collapse
      v-if="(((!contratosVazios && visualizaContratosVazios ) || (!contratosVazios && !visualizaContratosVazios) || (contratosVazios && visualizaContratosVazios)) && contratosMap && contratosMap.length > 0) && !shouldDisplayEmptyState"
      :value="collapseds"
      class="func-listagens"
    >
      <div v-for="(contrato, index) in contratosMap" :key="index">
        <el-collapse-item
          v-if="contrato.data.length > 0 || visualizaContratosVazios"
          :key="index"
          :name="index"
        >
          <template slot="title">
            <div>
              <h2>{{ contrato.plano }}</h2>
              <span class="sub">{{ textoVinculoContrato }}: {{ contrato.numeroContrato }}</span>
            </div>
          </template>
          <listagemStatus
            :columns="columns"
            :listagemData="contrato.data.slice(0, funcionalidade.parametros.quantidadeItensLista)"
            :status-field="'situacao'"
            :click-row="onClickRow"
            :no-hover="noHover"
            empty-message="Sem dados"
          />
          <el-button
            v-if="contrato.data.length > funcionalidade.parametros.quantidadeItensLista"
            class="btn-historico"
            plain
            @click="goToHistorico(contrato)"
          >
            Ver histórico <i class="el-icon-arrow-right"/>
          </el-button>
        </el-collapse-item>
      </div>
    </el-collapse>
    <div v-else>
      <div style="padding: 30px 18px" slot="append">
        <div class="text-center">
          <div style="margin-bottom: 20px">
            <inline-svg fill="#006FB9" height="120" style="" :src="require('@/assets/icons/img_helper_empty_default.svg')"/>
          </div>
          <span class="tituloVazio">
                  {{ funcionalidade.parametros.textos.tituloVazio }}
                </span><br/>
          <span class="textoVazio">
                  {{ funcionalidade.parametros.textos.textoVazio }}
                </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashItem from '@/components/dashboard/DashItem.vue'
import ListagemStatus from '@/components/listagemColumn/ListagemStatus.vue'
import StatusItem from '@/components/listagemColumn/StatusItem.vue'
import DataItem from '@/components/listagemColumn/DataItem.vue'
import MoedaItem from '@/components/listagemColumn/MoedaItem.vue'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import AcoesDebito from '@/views/14/AcoesDebito'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import { EnumTipoDeRelacionamento } from '@/views/14/Enums14'
import { mapGetters, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'

export default {
  name: 'Func14Listagem',
  data () {
    return {
      myData: '',
      debitos: [],
      comprovante: false
    }
  },
  components: {
    inlineSvg,
    FuncionalidadeHeader,
    DashItem,
    ListagemStatus
  },
  computed: {
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade', 'config']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem', 'textoVinculoContrato']),
    shouldDisplayEmptyState () {
      return this.contratosMap.every(contrato => contrato.data.length === 0)
    },
    columns () {
      return [
        { field: 'descricao' },
        {
          field: 'situacao',
          component: StatusItem,
          title: 'Situação'
        },
        [
          { field: 'dataVencimento', component: DataItem, title: 'Vencimento', showColumn: this.showColumnVencimento },
          { field: 'dataVencimentoAtualizado', component: DataItem, title: 'Vencimento Atualizado', showColumn: this.showColumnVencimentoAtualizado }
        ],
        [
          { field: 'valor', component: MoedaItem, cifra: 'R$', decimals: 2, title: 'Valor', showColumn: this.showColumnValor },
          { field: 'valorAtualizado', component: MoedaItem, cifra: 'R$', decimals: 2, title: 'Valor Atualizado', showColumn: this.showColumnValorAtualizado }
        ],
        this.defineColunaAcao
      ]
    },
    collapseds () {
      return [...Array(this.contratos.length).keys()]
    },
    contratosMap () {
      return this.contratos.map((contrato) => {
        let dadosLista = this.debitos.find(
          (debito) => contrato.numeroContrato === debito.numeroContrato
        ) || {}
        return {
          plano:
            `${contrato.descricaoContrato} - ${EnumTipoDeRelacionamento[contrato.tipoRelacionamento.codigo]}`,
          numeroContrato: contrato.numeroContrato,
          data: dadosLista.debitos || []
        }
      })
    },
    contratosVazios () {
      if (!this.contratosMap) return true
      return this.contratosMap.every(objeto => objeto.data.every(dado => Object.keys(dado).length === 0))
    },
    estiloLink () {
      if (!this.estilo.aplicacao) {
        return ''
      }
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao} !important`
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    estiloTituloNavegacao () {
      return {
        color: this.funcionalidade.parametros.corTituloNavegacao
      }
    },
    estiloIconeNavegacao () {
      return {
        color: this.funcionalidade.parametros.corIconeNavegacao
      }
    },
    estiloVoltarNavegacao () {
      return {
        color: this.funcionalidade.parametros.corVoltarNavegacao
      }
    },
    voltarNavegacao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return true
      }
    },
    defineColunaAcao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return { field: '', component: AcoesDebito }
        default:
          return { field: '', component: ArrowButton, acao: this.clickDetalhe }
      }
    },
    noHover () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    exibeVencimento () {
      return this.funcionalidade.parametros.exibicaoVencimento || 1
    },
    exibeValor () {
      return this.funcionalidade.parametros.exibicaoValor || 1
    },
    showColumnVencimento () {
      return [1, 3].includes(this.exibeVencimento)
    },
    showColumnValor () {
      return [1, 3].includes(this.exibeValor)
    },
    showColumnVencimentoAtualizado () {
      return [2, 3].includes(this.exibeVencimento)
    },
    showColumnValorAtualizado () {
      return [2, 3].includes(this.exibeValor)
    },
    visualizaContratosVazios () {
      if (!this.config.aplicacao) {
        return true
      }
      return this.config.aplicacao.visualizaContratosVazios
    }
  },
  methods: {
    async init () {
      await this.listaDetalhe()
    },
    onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return this.$router.push({
            path: '/14/detalhe',
            query: {
              idTitulo: row['idTitulo'],
              codigoTitulo: row['codigoTitulo'],
              nome: row['descricao']
            }
          })
      }
    },
    async listaDetalhe () {
      const response = await this.apiFuncionalidade.lista({
        loading: true,
        handlerErrorIgnore: [404]
      })
      this.debitos = response.data.contratos
    },
    clickDetalhe (row) {
      return this.$router.push({
        path: '/14/detalhe',
        query: {
          idTitulo: row['idTitulo'],
          codigoTitulo: row['codigoTitulo'],
          nome: row['descricao']
        }
      })
    },
    goToHistorico (contrato) {
      return this.$router.push({
        path: '/14/historico',
        query: {
          numeroContrato: contrato.numeroContrato
        }
      })
    },
    clickDownload (row) {
      alert(`Inicia Download do Boleto de id: ${row['idTitulo']}`)
    },
    clickComprovante (row) {
      alert(`Incia Download do Comprovante de id: ${row['idTitulo']}`)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
